import { LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntities } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntities'

export const useFetchCrmEntityEventsNoSuspense =
  LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntities.useQuery
